import * as managers from 'app/mocks/data/park/managers/list'

import type { CategoryProduct } from 'app/types/catalogue/product/category'

export const allergen1: CategoryProduct = {
    id: 1,
    name: 'Lait de vache',
    client: managers.manager1,
    priority: 1,
}

export const allergen2: CategoryProduct = {
    id: 2,
    name: 'Lait de chèvre',
    client: managers.manager1,
    priority: 2,
}

export const allergen3: CategoryProduct = {
    id: 3,
    name: 'Lait de brebis',
    client: managers.manager1,
    priority: 3,
}

export const allergen4: CategoryProduct = {
    id: 4,
    name: 'Œuf de poule',
    client: managers.manager1,
    priority: 4,
}

export const allergen5: CategoryProduct = {
    id: 5,
    name: 'Œuf de caille',
    client: managers.manager1,
    priority: 5,
}

export const allergen6: CategoryProduct = {
    id: 6,
    name: 'Arachides',
    client: managers.manager1,
    priority: 6,
}

export const allergen7: CategoryProduct = {
    id: 7,
    name: 'Noix',
    client: managers.manager1,
    priority: 7,
}

export const allergen8: CategoryProduct = {
    id: 8,
    name: 'Amandes',
    client: managers.manager1,
    priority: 8,
}

export const allergen9: CategoryProduct = {
    id: 9,
    name: 'Noisettes',
    client: managers.manager1,
    priority: 9,
}

export const allergen10: CategoryProduct = {
    id: 10,
    name: 'Soja',
    client: managers.manager1,
    priority: 10,
}

export const allergen11: CategoryProduct = {
    id: 11,
    name: 'Blé',
    client: managers.manager1,
    priority: 11,
}

export const allergen12: CategoryProduct = {
    id: 12,
    name: 'Seigle',
    client: managers.manager1,
    priority: 12,
}

export const allergen13: CategoryProduct = {
    id: 13,
    name: 'Crustacés',
    client: managers.manager1,
    priority: 13,
}

export const allergen14: CategoryProduct = {
    id: 14,
    name: 'Mollusques',
    client: managers.manager1,
    priority: 14,
}

export const allergen15: CategoryProduct = {
    id: 15,
    name: 'Poisson',
    client: managers.manager1,
    priority: 15,
}

export const allergen16: CategoryProduct = {
    id: 16,
    name: 'Céleri',
    client: managers.manager1,
    priority: 16,
}

export const allergen17: CategoryProduct = {
    id: 17,
    name: 'Moutarde',
    client: managers.manager1,
    priority: 17,
}

export const allergen18: CategoryProduct = {
    id: 18,
    name: 'Sésame',
    client: managers.manager1,
    priority: 18,
}

export const allergen19: CategoryProduct = {
    id: 19,
    name: 'Lupin',
    client: managers.manager1,
    priority: 19,
}

export const allergen20: CategoryProduct = {
    id: 20,
    name: 'Sulfites',
    client: managers.manager1,
    priority: 20,
}

export const allergen21: CategoryProduct = {
    id: 21,
    name: 'Kiwi',
    client: managers.manager1,
    priority: 21,
}

export const allergen22: CategoryProduct = {
    id: 22,
    name: 'Mangue',
    client: managers.manager1,
    priority: 22,
}

export const allergen23: CategoryProduct = {
    id: 23,
    name: 'Latex croisé',
    client: managers.manager1,
    priority: 23,
}

export const allergen24: CategoryProduct = {
    id: 24,
    name: 'Sarrasin',
    client: managers.manager1,
    priority: 24,
}

export const allergen25: CategoryProduct = {
    id: 25,
    name: 'Pêche',
    client: managers.manager1,
    priority: 25,
}

export const allergen26: CategoryProduct = {
    id: 26,
    name: 'Pomme',
    client: managers.manager1,
    priority: 26,
}

export const allergen27: CategoryProduct = {
    id: 27,
    name: 'Poire',
    client: managers.manager1,
    priority: 27,
}

export const allergen28: CategoryProduct = {
    id: 28,
    name: 'Avocat',
    client: managers.manager1,
    priority: 28,
}

export const allergen29: CategoryProduct = {
    id: 29,
    name: 'Carotte',
    client: managers.manager1,
    priority: 29,
}

export const allergen30: CategoryProduct = {
    id: 30,
    name: 'Pignon de pin',
    client: managers.manager1,
    priority: 30,
}

export const allergen31: CategoryProduct = {
    id: 31,
    name: 'Raisin',
    client: managers.manager2,
    priority: 1,
}

export const allergen32: CategoryProduct = {
    id: 32,
    name: 'Fraise',
    client: managers.manager2,
    priority: 2,
}

export const allergen33: CategoryProduct = {
    id: 33,
    name: 'Framboise',
    client: managers.manager2,
    priority: 3,
}

export const allergen34: CategoryProduct = {
    id: 34,
    name: 'Myrtille',
    client: managers.manager2,
    priority: 4,
}

export const allergen35: CategoryProduct = {
    id: 35,
    name: 'Mûre',
    client: managers.manager2,
    priority: 5,
}

export const allergen36: CategoryProduct = {
    id: 36,
    name: 'Groseille',
    client: managers.manager2,
    priority: 6,
}

export const allergen37: CategoryProduct = {
    id: 37,
    name: 'Cassis',
    client: managers.manager2,
    priority: 7,
}

export const allergen38: CategoryProduct = {
    id: 38,
    name: 'Canneberge',
    client: managers.manager2,
    priority: 8,
}

export const allergen39: CategoryProduct = {
    id: 39,
    name: 'Airelle',
    client: managers.manager2,
    priority: 9,
}

export const allergen40: CategoryProduct = {
    id: 40,
    name: 'Baie de goji',
    client: managers.manager2,
    priority: 10,
}

export const allergen41: CategoryProduct = {
    id: 41,
    name: 'Pistache',
    client: managers.manager3,
    priority: 1,
}

export const allergen42: CategoryProduct = {
    id: 42,
    name: 'Noix de cajou',
    client: managers.manager3,
    priority: 2,
}

export const allergen43: CategoryProduct = {
    id: 43,
    name: 'Noix de pécan',
    client: managers.manager3,
    priority: 3,
}

export const allergen44: CategoryProduct = {
    id: 44,
    name: 'Noix du Brésil',
    client: managers.manager3,
    priority: 4,
}

export const allergen45: CategoryProduct = {
    id: 45,
    name: 'Noix de macadamia',
    client: managers.manager3,
    priority: 5,
}

export const allergen46: CategoryProduct = {
    id: 46,
    name: 'Noix de coco',
    client: managers.manager3,
    priority: 6,
}

export const allergen47: CategoryProduct = {
    id: 47,
    name: 'Châtaigne',
    client: managers.manager3,
    priority: 7,
}

export const allergen48: CategoryProduct = {
    id: 48,
    name: 'Noisette verte',
    client: managers.manager3,
    priority: 8,
}

export const allergen49: CategoryProduct = {
    id: 49,
    name: 'Pignon de pin',
    client: managers.manager3,
    priority: 9,
}

export const allergen50: CategoryProduct = {
    id: 50,
    name: 'Noix de kola',
    client: managers.manager3,
    priority: 10,
}

export const allergen51: CategoryProduct = {
    id: 51,
    name: 'Noix de karité',
    client: managers.manager3,
    priority: 11,
}

export const allergen52: CategoryProduct = {
    id: 52,
    name: 'Noix de muscade',
    client: managers.manager3,
    priority: 12,
}

export const allergen53: CategoryProduct = {
    id: 53,
    name: 'Noix de ginkgo',
    client: managers.manager3,
    priority: 13,
}

export const allergen54: CategoryProduct = {
    id: 54,
    name: 'Marron',
    client: managers.manager3,
    priority: 14,
}

export const allergen55: CategoryProduct = {
    id: 55,
    name: 'Praline',
    client: managers.manager3,
    priority: 15,
}
